import MatrixBackground from "../components/MatrixBackground";
import InteractiveTerminal from "../components/InteractiveTerminal";

const ContactTerminal = () => (
  <div className="min-h-screen pt-24 px-4 relative text-slate-100 bg-black">
    <MatrixBackground />
    <InteractiveTerminal />
  </div>
);

export default ContactTerminal;
